import { initNewsletterForm } from "@/scripts/sections/newsletter-form-handler"

document
  .querySelectorAll("form.newsletter-form--page[data-newsletter-form]")
  .forEach((form) => {
    initNewsletterForm(form)

    const submitBtn = form.querySelector("[data-newsletter-submit]")
    const checkboxes = form.querySelectorAll("[data-consent-checkbox]")
    const toggleSubmit = () => {
      const anyChecked = Array.from(checkboxes).some((cb) => cb.checked)
      submitBtn.disabled = !anyChecked
      submitBtn.classList.toggle("button--secondary", !anyChecked)
      submitBtn.classList.toggle("button--primary", anyChecked)
      submitBtn.classList.toggle("button--primary_white", anyChecked)
    }
    checkboxes.forEach((cb) => cb.addEventListener("change", toggleSubmit))
    toggleSubmit()
  })
